export default function pointsTypesReducer(state = {
  pointsTypes: [],
  pointsType: null,
  fetching: false,
  fetched: false,
}, action) {
  switch (action.type) {
    case 'GET_POINTS_TYPES_LIST_PENDING':
    case 'GET_POINTS_TYPE_PENDING': {
      return {...state, fetching: true, fetched: false};
    }
    case 'GET_POINTS_TYPES_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pointsTypes: action.payLoad.data,
      };
    }
    case 'GET_POINTS_TYPE_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pointsType: action.payLoad.data,
      };
    }
    case 'GET_POINTS_TYPES_LIST_REJECTED':
    case 'GET_POINTS_TYPE_REJECTED': {
      return {...state, errors: action.payLoad.errors};
    }
    default:
  }

  return {...state};
}
